import { useState, useEffect } from "react";
import style from "./Style.module.css";
import Util from "../../Util";

const Index = (props) => {
  const [report, setReport] = useState(props.report);

  useEffect(() => {
    setReport(props.report);
  }, [props.report]);

  const setRep = (field, value) => {
    let reportTemp = props?.report;
    reportTemp[field] = value;
    setReport({ ...reportTemp });
  };

  const submitReport = async () => {
    const id = props?.reportID;
    const data = await Util.sendPost("/api/user/addMyReport", {
      sheet: id,
      message: report.message,
      category: report.category,
    });
    if (!data.success) {
      alert(data.msg);
    } else {
      alert(
        "Report ของคุณถูกส่งให้ผู้เขียนชีทแล้ว หากมีการเปลี่ยนแปลงจากทางผู้เขียนจะมีการแจ้งเตือนมาถึงคุณ"
      );
      setReport({ message: "" });
      props.onClose();
    }
  };

  if (props.showReport === false) return null;

  return (
    <div className={style.reportBox}>
      <div className={style.rClose} onClick={props.onClose}>
        X
      </div>
      <div className={style.rHeader}>Report</div>
      <div className={style.rsn}>ชีท: {props?.reportName}</div>
      <hr />
      <div className={style.rLabel}>เหตุผล</div>
      <select
        onChange={(event) => setRep("category", event.currentTarget.value)}
        className={style.tSelect}
        value={report?.category}
      >
        <option value="ชีทอ่านไม่รู้เรื่อง" label="ชีทอ่านไม่รู้เรื่อง">
          ชีทอ่านไม่รู้เรื่อง
        </option>
        <option
          value="ชีทพื้นที่ว่างเยอะเกินไป"
          label="ชีทพื้นที่ว่างเยอะเกินไป"
        >
          ชีทพื้นที่ว่างเยอะเกินไป
        </option>
        <option value="ชีทเนื้อหาไม่ครบถ้วน" label="ชีทเนื้อหาไม่ครบถ้วน">
          ชีทเนื้อหาไม่ครบถ้วน
        </option>
        <option value="ชีทมีการละเมิดลิขสิทธิ์" label="ชีทมีการละเมิดลิขสิทธิ์">
          ชีทมีการละเมิดลิขสิทธิ์
        </option>
      </select>
      <hr />
      <div className={style.rLabel}>
        ข้อความเพิ่มเติม (ไม่เกิน 200 ตัวอักษร)
      </div>
      <textarea
        onChange={(event) => setRep("message", event.currentTarget.value)}
        className={style.tAreaLong}
        value={report.message}
      />
      <div className={style.bGroup}>
        <div className={style.rAddRed} onClick={submitReport}>
          ส่ง Report
        </div>
      </div>
    </div>
  );
};

export default Index;
